<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon
          slot="icon-only"
          name="close"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Member Lookup</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="edit-guest-content ion-padding">
  <div class="edit-guest-shell">
    <p class="edit-guest-message">
      Search by name or member ID. Tap a member to see linked guest profile and order history, then tap Select member
      below.
    </p>

    <div class="assign-layout">
      <div class="card-shell">
        <div class="card-title-row">
          <div class="card-title">Search members</div>
        </div>
        <ion-item lines="none">
          <ion-segment
            [(ngModel)]="searchOption"
            class="search-mode-segment"
          >
            <ion-segment-button value="fullName">
              <ion-label>Name</ion-label>
            </ion-segment-button>
            <ion-segment-button value="memberId">
              <ion-label>Member ID</ion-label>
            </ion-segment-button>
          </ion-segment>
        </ion-item>
        <div class="search-row">
          <ion-input
            class="form-input"
            type="text"
            [placeholder]="searchOption === 'memberId' ? 'Member ID' : 'Name'"
            [(ngModel)]="searchValue"
            (keyup.enter)="search()"
          ></ion-input>
          <ion-button
            class="search-action-btn"
            fill="solid"
            color="secondary"
            (click)="search()"
          >
            Search
          </ion-button>
        </div>

        <ng-container *ngIf="hasSearched">
          <div class="card-title card-title--secondary">Results</div>
          <div class="results-list">
            <button
              type="button"
              class="result-card"
              *ngFor="let row of rows; trackBy: trackByMemberId"
              [class.result-card--selected]="selectedRow?.member?.id === row.member.id"
              (click)="selectRow(row)"
            >
              <div class="result-card__name">{{ row.member.data?.fullName }}</div>
              <div class="result-card__meta">Member ID: {{ row.member.data?.memberId }}</div>
              <div
                class="result-card__meta"
                *ngIf="row.member.data?.status === 'flagged'"
              >
                {{ row.member.data?.status | titlecase }}
                <ng-container *ngIf="row.member.data?.comment"> — {{ row.member.data?.comment }}</ng-container>
              </div>
              <div
                class="result-card__meta"
                *ngIf="row.guest?._id"
              >
                Guest: {{ row.guest.name }} · Orders: {{ row.guest.ordersSummary?.orders ?? 0 }}
              </div>
              <div
                class="result-card__meta"
                *ngIf="!row.guest?._id"
              >
                No linked guest profile
              </div>
            </button>
            <div
              class="results-empty"
              *ngIf="!rows.length"
            >
              No members found
            </div>
          </div>
        </ng-container>
      </div>

      <div class="card-shell profile-card">
        <div class="card-title">Profile snapshot</div>
        <ng-container *ngIf="selectedRow; else emptyProfile">
          <div class="profile-card__avatar">{{ getInitials(selectedRow.member.data?.fullName) }}</div>
          <div class="profile-card__name">{{ selectedRow.member.data?.fullName }}</div>
          <div class="profile-card__sub">Member account</div>
          <div class="profile-card__row">
            <span>Member ID</span>
            <strong>{{ selectedRow.member.data?.memberId }}</strong>
          </div>
          <div
            class="profile-card__row"
            *ngIf="selectedRow.member.data?.status === 'flagged'"
          >
            <span>Status</span>
            <strong>{{ selectedRow.member.data?.status | titlecase }}</strong>
          </div>
          <div
            class="profile-card__row"
            *ngIf="selectedRow.member.data?.comment"
          >
            <span>Note</span>
            <strong>{{ selectedRow.member.data?.comment }}</strong>
          </div>
          <div class="profile-card__row">
            <span>Linked guest</span>
            <strong>{{ selectedRow.guest?.name || 'None' }}</strong>
          </div>
          <div class="profile-card__row">
            <span>Email</span>
            <strong>{{ selectedRow.guest?.email || 'Not provided' }}</strong>
          </div>
          <div class="profile-card__row">
            <span>Phone</span>
            <strong>{{
              selectedRow.guest?.phone ? (selectedRow.guest.phone | phone) : 'Not provided'
            }}</strong>
          </div>
          <div class="profile-card__row">
            <span>Orders (guest)</span>
            <strong>{{ selectedGuestOrders }}</strong>
          </div>
          <div class="profile-card__row">
            <span>Lifetime spend (guest)</span>
            <strong>{{
              selectedGuestLifetimeSpend * 0.01 | currency : 'USD' : 'symbol' : '1.2-2'
            }}</strong>
          </div>
        </ng-container>
        <ng-template #emptyProfile>
          <div class="results-empty profile-empty">Select a member from the list to preview guest and order history.</div>
        </ng-template>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-row class="ion-padding edit-guest-footer">
    <ion-col>
      <ion-button
        class="primary-action-btn"
        expand="block"
        color="secondary"
        [disabled]="!selectedRow"
        (click)="confirmSelection()"
      >
        Select member
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
